import React from "react";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Box, Paper, Rating, Typography } from "@mui/material";

import StarIcon from "@mui/icons-material/Star";
const TestimonialSlider = ({ name, value, description, image }) => {
  return (
    <>
      <Box display={"flex"} justifyContent={"center"} overflow={'hidden'} mx={'10px'}>
        <Box>
          <Paper
            className="testimonial-content"
            elevation={22}
            sx={{
              p: 5,
              boxShadow: 8,
              borderRadius: "9px",
              zIndex: 1,
              width: "100%",
              height: "348px",
            }}
          >
            <Box display={"flex"}>
              <img src={image}  alt="slider"/>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"space-between"}
                justifyContent={"space-around"}
   
              >
                <Typography>{name}</Typography>
                <Rating
                  name="text-feedback"
                  value={value}
                  readOnly
                  precision={0.5}
                  emptyIcon={
                    <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                  }
                />
              </Box>
            </Box>
            <Typography sx={{ marginTop: "60px" }}>{description}</Typography>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default TestimonialSlider;
